import "./App.css";
import { ToastContainer } from "react-toastify";
import Router from "./router/router";
import React, { useEffect } from "react";
import { onAuthStateChanged, signInAnonymously } from "firebase/auth";
import { auth, messaging } from "./firebase";
import { onMessage } from "firebase/messaging";
import { useDispatch } from "react-redux";
import { addNotification } from "./redux/notificationSlice";
import Notification from "./components/Notifications";

function App() {
  const dispatch = useDispatch();

  const authenticateAnonymously = async () => {
    try {
      const userCredential = await signInAnonymously(auth); // Pass auth instance

      const accessToken = await userCredential.user.getIdToken();

      localStorage.setItem("accessToken", accessToken);
    } catch (error: any) {
      console.error("Anonymous authentication failed:", error.message);
    }
  };

  const refreshToken = async (user: any) => {
    try {
      const token = await user.getIdToken(true);
      localStorage.setItem("accessToken", token);
    } catch (error) {
      console.error("Token refresh failed:", error);
    }
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        refreshToken(user);
      } else {
        authenticateAnonymously();
      }
    });

    return () => unsubscribe();
  }, []);

  const handleNotification = (payload: any, source: 'foreground' | 'background') => {

    if (source === 'foreground') {
      const notification = {
        id: payload.messageId || Date.now(),
        title: payload.notification?.title || "Notification",
        body: payload.notification?.body || "",
        orderId: payload.data?.orderId || "",
        orderStatus: payload.data?.orderStatus || "",
        timestamp: Date.now()
      };
      dispatch(addNotification(notification));
    }
    if (source === 'background') {
      const notification = {
        id: payload.id || Date.now(),
        title: payload.notification?.title || "Notification",
        body: payload?.body || "",
        orderId: payload.id || "",
        orderStatus: payload?.orderStatus || "",
        timestamp: Date.now()
      };
      dispatch(addNotification(notification));
    }
  };

  // Foreground messages
  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload) => {
      handleNotification(payload, 'foreground');
    });

    return unsubscribe;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  // Background messages via service worker
  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    const messageHandler = (event: MessageEvent) => {
      if (event.data?.type === 'NEW_BACKGROUND_NOTIFICATION') {
        handleNotification(event.data.payload, 'background');
      }
    };

    // Add listener
    navigator.serviceWorker.addEventListener('message', messageHandler);

    // Initialize service worker communication
    navigator.serviceWorker.ready.then(registration => {
      registration.active?.postMessage({ type: 'INIT_CLIENT' });
    });

    return () => {
      navigator.serviceWorker.removeEventListener('message', messageHandler);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <>
      <Router />
      <ToastContainer />
      <Notification />
    </>
  );
}

export default App;
